import React from "react";
import { Card } from "react-bootstrap";
import "./DistrictCard.css";

const DistrictCard = ({ districtName, onClick }) => {
  return (
    <Card className="district-card" onClick={() => onClick(districtName)}>
      <Card.Body className="district-card-body">
        <h5 className="district-card-title">{districtName?.toUpperCase()}</h5>
      </Card.Body>
    </Card>
  );
};

export default DistrictCard;
